// extracted by mini-css-extract-plugin
export default {"form-title-wrap":"formTitle_form-title-wrap__vggbK","form-title-subtext":"formTitle_form-title-subtext__oEMaM"};